import '../styles/Main.css';
import { Modal } from 'react-bootstrap';
import { useActions, useTypedSelector } from '../../hooks';
import Icon from '../../resources/images/BatuLightning@3x.png';
import { FormButton } from '../common';

const CFECredentialsModal: React.FC = () => {
  const needsCFECredentials = useTypedSelector(({ ui }) => {
    return ui.needsCFECredentials;
  });
  const { userNeedsCfeCredentials, dontRemindUserCfeCredentials } =
    useActions();
  return (
    <Modal
      show={needsCFECredentials}
      onHide={() => userNeedsCfeCredentials(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="welcome-to-batu-popup"
      contentClassName="welcome-to-batu-popup-content"
    >
      <Modal.Body className="welcome-to-batu-popup-body">
        <div className="welcome-to-batu-popup-image-container">
          <img
            src={Icon}
            alt="Batu logo"
            className="batu-lightning-popup-image"
          />
        </div>
        <div className="main-popup-message-container">
          <h2 className="main-popup-message-container-title">
            ¿Quieres más historial?
          </h2>
          <h5 className="main-popup-message-container-subtitle">
            Podríamos descargar 12 meses de datos pero necesitamos que nos
            habilites un acceso a CFE Mi Espacio.
          </h5>
          <h5 className="main-popup-message-container-text">
            Para habilitar esta función contáctanos a través de{' '}
            <a href="mailto:contacto@batuenergy.com">contacto@batuenergy.com</a>
            .
          </h5>
          <div className="main-popup-message-container-buttons">
            <FormButton
              content="No me recuerdes"
              disabled={false}
              onSubmit={() => {
                dontRemindUserCfeCredentials(true);
                userNeedsCfeCredentials(false);
              }}
            />
            <FormButton
              content="Ok"
              disabled={false}
              onSubmit={() => {
                userNeedsCfeCredentials(false);
              }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export { CFECredentialsModal };
